import React from 'react';
import '../css/preloader.css';

export const Preloader = ({ colorSelected = 'var(--theme-company)' }) => {
  return (
    <div className="preloader-container">
      <div className="spinner" style={{ borderTopColor: colorSelected }}></div>
      <p style={{ color: colorSelected }}>Cargando...</p>
    </div>
  );
};

